module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('hr'), _vm._v(" "), _c('h4', [_vm._v("Scheduler")]), _vm._v(" "), (_vm.json && _vm.json.schedulers) ? _c('div', [_c('div', {
    staticClass: "description"
  }, [_vm._v("\n            You can pick from the following scheduling policies to run the simulation for this tutorial:\n        ")]), _vm._v(" "), _vm._l((_vm.json.schedulers), function(scheduler) {
    return _c('radio', {
      attrs: {
        "selected-value": scheduler,
        "type": "success"
      },
      model: {
        value: (_vm.selected),
        callback: function($$v) {
          _vm.selected = $$v
        },
        expression: "selected"
      }
    }, [_vm._v("\n            " + _vm._s(_vm.schedulerType[scheduler].name) + "\n            "), (_vm.selected == scheduler) ? _c('div', {
      staticClass: "description"
    }, [_vm._v(_vm._s(_vm.schedulerType[scheduler].description))]) : _vm._e()])
  })], 2) : _vm._e(), _vm._v(" "), (!_vm.json || !_vm.json.schedulers) ? _c('div', {
    staticClass: "description"
  }, [_vm._v("\n        This tutorial does not specify any schedulers; default "), _c('strong', [_vm._v("round-robin")]), _vm._v(" scheduler will be used.\n    ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c62dc3a8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tutorialPicker/schedulerPicker.vue
// module id = 1553
// module chunks = 2